export enum ClientChoreStatus {
  new = 'new',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
}
